import { ADD_JOB } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_JOB.LOAD:
      return {
        ...state,
        loading: true
      };
    case ADD_JOB.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case ADD_JOB.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
